<template>
  <div class="settlement">
    <EsHeaderView />
    <div class="settlement-content app-container" v-loading="loading"   >
      <h1 class="title">{{ $t("message.home.checkout") }}</h1>
      <h2 class="subtitle">{{ $t("message.home.shippingAddress") }}</h2>
      <div class="settlement-receiver flex-between" @click="selectAddressEvent">
        <div>
          <div class="userinfo">
            <span v-if="defaultAddress && defaultAddress.phone">
              {{ defaultAddress.consignee }} +{{ defaultAddress.phone }}
            </span>
          </div>
          <p class="address" v-if="defaultAddress && defaultAddress.address">
            {{ defaultAddress.regionName }}{{ defaultAddress.address }}
          </p>
        </div>
        <div><i class="el-icon-arrow-right"></i></div>
      </div>
      <!----------------------------------------------------------------------------------------------------->


      <div class="settlement"  >
        <div class="settlement-commodity" v-for="(item, index) in obj.orders" :key="index">
          <!-- {{ checkProductPay }} -->
          <!-- <el-checkbox class="settlement-commodity-title" v-model="item.checkAll" :indeterminate="item.isIndeterminate"
            @change="handleCheckAllChange($event, index)">
            {{ item.list[0].seller.name }}（{{ $t("message.home.totalOf") }}
            {{ item.checkList.length }} {{ $t("message.home.items") }}）
          </el-checkbox> -->
          <div class="settlement-commodity-title">
            {{ item.storeName }}
            <!-- {{ item.checkList.length }} {{ $t("message.home.items") }}） -->
          </div>
          <div class="settlement-commodity-group">
            <div class="settlement-commodity-wrap" v-for="(items, index2) in item.orderItems" :key="index2">
              <!-- <el-checkbox :label="items.id" class="settlement-commodity-checkbox flex-between"> -->
              <div class="settlement-commodity-item flex-start">
                <img :src="items.thumbnail" alt="" />
                <div class="flex-start settlement-commodity-info"
                  :style="{ flexDirection: 'column', alignItems: 'flex-start' }">
                  <div>
                    <h2 :title="items.name">{{ items.name }}</h2>
                    <p>
                      ${{ items.price }}
                    </p>
                    <!-- <p v-else>
                          ${{
                            childItem.discountPrice ?? childItem.sellingPrice
                          }}
                        </p> -->
                  </div>
                  <div class="settlement-commodity-info-attr"
                    v-if="items.specifications && items.specifications.length > 0">
                    <span>{{ $t("message.home.orderSpecification") }}:</span>
                    <span><span style="margin-left: 30rpx;"
                        v-if="items.specifications && items.specifications.length > 0">[</span><span
                        v-for="(it, idx) in items.specifications" :key="idx">{{ " " + it + " " }}</span><span
                        v-if="items.specifications && items.specifications.length > 0">]</span></span>
                  </div>
                </div>
              </div>
              <!-- </el-checkbox> -->
              <div style="width: 100px;position: absolute;top: 30px;right: 24px;">x {{ items.quantity }}</div>
              <!-- <el-input-number v-model="item.quantity" size="mini" key="item.quantity"
                  @blur="changeNum(childItem, event)" :precision="0"  /> -->
            </div>
          </div>
        </div>
      </div>


      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsOrderList /> -->

      <!----------------------------------------------------------------------------------------------------->

      <div class="order-sum">
        <h1>{{ $t("message.home.orderSummary") }}</h1>
        <ul class="order-sum-content">
          <!-- <li
        v-for="(item, index) in orderSum"
        :key="index"
        :class="{ total: index === orderSum.length - 1, 'flex-between': true }"
      >
        <span>{{ item.name }}</span>
        <span> {{ item.value }} </span>
      </li> -->

          <li class="flex-between">
            <span>商品合计金额</span>
            <span>{{ obj.price || '0' }}</span>
          </li>

          <li class="total flex-between">
            <span>运费</span>
            <span>{{ obj.freight || '0' }}</span>
          </li>
          <li class="total flex-between">
            <span>赠送积分</span>
            <span>{{ obj.rewardPoint || '0' }}</span>
          </li>
          <li class="total flex-between">
            <span>促销折扣</span>
            <span>{{ obj.marketingDiscount || '0' }}</span>
          </li>
          <li class="total flex-between">
            <span>优惠券折扣</span>
            <span>{{ obj.couponDiscount || '0' }}</span>
          </li>

        </ul>
      </div>

      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsOrderSum :checkGoods="chcekData" /> -->

      <!----------------------------------------------------------------------------------------------------->

      <div class="pay-method">
        <h1 v-if="showTitle">{{ $t('message.home.paymentMethod') }}</h1>
        <ul class="pay-method-content">
          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/Union.png')" alt="" />
              <p class="name">
                <span>{{ $t('message.home.Balance') }}</span>
                (
                <span class="amount">${{obj.amountPayable||'0'}}</span>
                )
              </p>
            </div>
            <el-radio  :label="1"></el-radio>
          </li> -->
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/Union.png')" alt="" />
              <p class="name">
                <span>Biz System</span>
                <span class="amount"></span>
              </p>
            </div>
            <el-radio v-model="paymentMethodRadio" :label="1"></el-radio>
          </li>
          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/pay.png')" alt="" />
              <p class="name">
                <span>{{ $t('message.home.payPal') }}</span>
              </p>
            </div>
            <el-radio  v-model="paymentMethodRadio" :label="2" ></el-radio>
          </li> -->

          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/visa.png')" alt="" />
              <p class="name">
                <span>支付宝</span>
              </p>
            </div>
            <el-radio  v-model="paymentMethodRadio" :label="3" ></el-radio>
          </li>
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/master.png')" alt="" />
              <p class="name">
                <span>微信</span>
              </p>
            </div>
            <el-radio  v-model="paymentMethodRadio" :label="4" ></el-radio>
          </li> -->



          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/visa.png')" alt="" />
              <p class="name">
                <span>Visa</span>
              </p>
            </div>
            <el-radio  v-model="radio" :label="3" ></el-radio>
          </li>
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/master.png')" alt="" />
              <p class="name">
                <span>{{ $t('message.home.mastercard') }}</span>
              </p>
            </div>
            <el-radio  v-model="radio" :label="4" ></el-radio>
          </li> -->
        </ul>
      </div>

      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsPayMethod /> -->

      <div class="settlement-pay flex-between">
        <div class="settlement-pay-label">
          <!-- {{ $t("message.home.Opt") }}
          <span>{{ checkNum }}</span>
          {{ $t("message.home.piece") }} -->
        </div>
        <el-button type="primary"  @click="formSubmit">
          <span>{{ $t("message.home.subOrder") }}</span>
          <span>${{ obj.amountPayable || '0' }}</span>
        </el-button>
      </div>
      <EsIconTips />
    </div>
    <EsFooterView />

    <!-- <EsPayModal   :payCallback="payCallback"  @changeShowModel="changeShowModel"  /> -->

    <template>
      <el-dialog :visible.sync="payModalShow" class="es-dialog" :append-to-body="true" width="475px">
        <div slot="title" class="dialog-title">
          <span v-if="showModel === 0">确认</span>
          <span v-if="showModel === 1">{{ $t('message.home.setUpPayPaw') }}</span>
          <span v-if="showModel === 2">{{ $t('message.home.confirmPayPaw') }}</span>
        </div>
        <div class="pay-modal-content dialog-content">
          <h2 style="width: 100% ;line-height: 120px;text-align: center;" class="pay-modal-title">确定支付订单？</h2>
          <!-- <h2 class="pay-modal-title" v-if="showModel === 2">
            {{ $t('message.home.desc6') }}
          </h2> -->
          <!-- <EsPayPassword ref="passwordRef" :type="'password'" :maxlength="6" /> -->
          <div class="pay-modal-btn">
            <el-button type="primary" :loading="loading" @click="payment_outLinePay" v-if="showModel === 0">
              {{ $t('message.home.确认') }}
            </el-button>
            <!-- <el-button type="primary" :loading="loading" @click="setUpPaw" v-if="showModel === 1">
              {{ $t('message.home.确认') }}
            </el-button> -->
            <!-- <div v-if="showModel === 2" class="pay-button-view">
              <el-button :loading="loading" @click="previous">
                {{ $t('message.home.previous') }}
              </el-button>
              <el-button type="primary" :loading="loading" @click="confirmPayPaw">
                {{ $t('message.home.确认') }}
              </el-button>
            </div> -->
          </div>
        </div>
        <span slot="footer"></span>
      </el-dialog>
    </template>


    <!---------------------------------------------------------------------------------------------------->


    <el-dialog class="es-dialog" :visible.sync="dialogVisible" :center="true" :append-to-body="true" width="600px">
      <div slot="title" class="dialog-title">
        <span>{{ $t('message.home.selectDeliveryAddress') }}</span>
      </div>
      <div class="address-modal-content dialog-content">
        <div :class="{
          'address-active': paySelectAddress.id === item.id,
          item: true,
        }" v-for="item in addressList" :key="item.id">
          <div class="info">
            <span class="name">{{ item.contacts }}</span>
            <span class="mobile">&nbsp;&nbsp;+{{ item.phone }}</span>
          </div>
          <div class="address">
            {{ item.country }} {{ item.province }} {{ item.city }}
            {{ item.address }}
          </div>
        </div>
        <div class="item">
          {{ $t('message.home.addNewAddress') }}
        </div>
      </div>
      <span slot="footer"></span>
    </el-dialog>


    <!---------------------------------------------------------------------------------------------------->


    <AddressDialog v-model="addAddressModalShow" @showAddAddressView="showAddAddressView" />
    <AddAddressDialog :addAddressView="addAddressView" @showAddAddressView="showAddAddressView" />
    <EsAddAddress v-model="addAddressView" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import EsIconTips from "@/components/iconTips";
// import EsOrderSum from "./orderSum.vue";
// import EsOrderList from "./orderList.vue";
// import EsPayMethod from "./payMethod.vue";
// import EsPayModal from "./payModal.vue";
import AddressDialog from "./address";
import AddAddressDialog from '@/components/addAddress'
import { setCartItemsLocal, getCartItemsLocal } from "@/util/shop";
// import { numberFormat } from "@/util";
import EsAddAddress from "@/components/addAddress";
import EsPayPassword from "@/components/payPassword";


//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  check_coupon,
  address_list,
  payment,
  calculate,
  create,
  add_address,
  checkout
} from "@/api/order/order.js"
import {
  load,
  testPostPay,
} from "@/api/order/payment.js"

//////////////////////////////////////////////////////////////////////////////////////////////////

export default {
  name: "EsSettlement",
  components: {
    EsIconTips,
    // EsOrderSum,
    // EsOrderList,
    // EsPayMethod,
    // EsPayModal,
    AddressDialog,
    AddAddressDialog,
    EsAddAddress,
    // EsPayPassword,
  },
  data() {
    return {

      payModalShow: false,
      addAddressModalShow: false,
      selectAddress: {},
      currentSubmitOrderIds: [],
      addAddressView: false,
      chcekData: [],
      checkNum: 0,
      lastSubmit: {
        orderIds: "",
        addressId: "",
        orderInfo: {},
      },

      orderSum: [
        {
          name:
            this.$t("message.home.commodity") + this.$t("message.home.amount"),
          value: `$0`,
        },
        {
          name: this.$t("message.home.discount"),
          value: "-$0.00",
        },
        {
          name: this.$t("message.home.tax"),
          value: "+$0.00",
        },
        {
          name: this.$t("message.home.deliveryFee"),
          value: "+$0.00",
        },

        {
          name: this.$t("message.home.totalNum"),
          value: `$22`,
        },
      ],

      showTitle: true,
      dialogVisible: false,
      loading: false,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      paymentMethodRadio: 1,

      orderBy: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 

      total: 0,
      goods: [],
      goodsId: "",
      index: 0,
      userInfo: {},
      orderInfo: {},
      loadingHidden: false,
      carts: [],
      showcartlist: false,
      is_check: false,
      invoiceShow: false,
      addressId: "",
      ogoodsId: "",
      ototal: 0,
      buyFlag: 1, //1购物车购买  2 直接购买



      obj: {},
      objsList: [],
      skuId: null,
      marketingId: null,
      skuQuantity: 0,
      paymentPatterns: [],
      shippingMethods: [],
      coupons: [],
      defaultAddress: {},
      indexPM: 0,
      indexSM: 0,
      indexCC: 0,
      formData: {
        skuId: null, //直接购买  skuId
        marketingId: null,
        notJoinGroup: false,
        quantity: 0, //直接购买  数量
        addressId: null, //地址
        paymentPatternId: null, //支付方式
        shippingMethodId: null, //配送方式
        code: null, //优惠码
        invoiceTitle: null, //发票 白头
        invoiceTaxNumber: null, //税号
        invoiceContent: null, //发票内容
        balance: 0, //余额   
        remark: null, //备注
        currentCartId: null, //购物车
      },
      notJoinGroup: false,
      orders: [],
      orderSns: null,
      orderType: null,

      password: '',
      // 0 支付界面 1 设置支付密码 2 确认支付密码
      showModel: 0,


      totalPrice: 0,
      paymentItemListForm: {
        paymentItemList: []
      }, //支付项
      online: null,
      defaultPayment: null,
      payments: null,
      shippingMethodName: null,
      paymentPatternName: null,
      paymentPattern: null,
      expireDate: null,
      paymentLog: null,
      payPalOrderInfo: {},
      num: 0.01

      //////////////////////////////////////////////////////////////////////////////////////////////////
    };
  },
  computed: {
    ...mapGetters({
      addressList: "user/addressList",
      // defaultAddress: "user/defaultAddress",
      paySelectAddress: "user/paySelectAddress",
      checkProductPay: "cart/checkProductPay",
      userBalance: "user/userBalance",
      currentCart: "currentCart"
      // userInfo: "userInfo",
    }),
    checkCount() {
      // return null;
      return this.checkProductPay.reduce(
        (a, b) => a + b.list.reduce((i, l) => i + l.checkTotal, 0),
        0
      );
    },
    checkTotalAmount() {
      return this.getChcekData().reduce(
        (a, b) =>
          a +
          ((b.price || b.discountPrice || b.sellingPrice) +
            (b.goodsTax ?? 0) +
            (b.freightAmount ?? 0)) *
          b.checkTotal,
        0
      )
    },
    isDisabledPayBtn() {
      return (
        this.userBalance <= 0 ||
        this.checkCount <= 0 ||
        this.userBalance < this.checkTotalAmount
      );
    },
    // checkProduct() {
    //     return this.getChcekData();
    // }
  },
  async mounted() {
    // await this.requestAddressList();
    // this.$nextTick(() => {
    //   this.updatePaySelectAddress(this.defaultAddress);
    // });


    this.checkout_init();
    // uni.$on('addressLoadSuccess', (data) => {
    // 	this.defaultAddress = data;
    // 	if(data){
    // 		this.formData.addressId = this.defaultAddress.id;
    // 		this.checkout_calculate();
    // 	}else{
    // 		this.formData.addressId = null;
    // 	}
    // 	// this.defaultAddress = data?data:null;
    // 	// this.formData.addressId = data?this.defaultAddress.id?null;
    // 	// this.checkout_init(options);
    // });

  },
  methods: {
    ...mapMutations({
      updatePaySelectAddress: "user/updatePaySelectAddress",
      updateCheckProductPay: "cart/updateCheckProductPay",
      updateCartItems: "cart/updateCartItems",
    }),
    ...mapActions({
      requestAddressList: "user/requestAddressList",
      requestOrderPay: "order/requestOrderPay",
      setSafewordFunc: "order/setSafewordFunc",
      requestOrderSubmit: "order/requestOrderSubmit",
    }),
    changeShowModel(e) {
      this.showModel = e;
    },
    showAddAddressView(bool) {
      this.addAddressView = !this.addAddressView;
      if (!this.addAddressView) {
        this.requestAddressList();
      }
    },
    getChcekData() {
      let data = [];
      this.checkProductPay.forEach((item) => {
        data = [
          ...data,
          ...item.list.filter(
            (listItem) => item.checkList.indexOf(listItem.Identifier) > -1
          ),
        ];
      });
      this.chcekData = data;
      this.checkNum = data.length;
      return data;
    },
    async pay() {
      // if (!this.paySelectAddress?.id) {
      //   return this.$message.error(
      //     this.$t("message.home.ShippingAddressNotSet" /* 未设置收货地址 */)
      //   );
      // }

      // const checkData = this.getChcekData();
      // // const ids = checkData.map((item) => item.id)

      // checkData.map((item) => [item.id, item.checkTotal]).join(",");

      // const orderInfo = checkData
      //   .map((item) => [item.id, item.skuid || -1, item.checkTotal])
      //   .join(",");
      // if (!orderInfo) {
      //   return this.$message.error(
      //     this.$t("message.home.NoProductSelected" /* 请选择商品 */)
      //   );
      // }
      // const addressId = this.paySelectAddress.id;
      // if (
      //   !(
      //     this.lastSubmit.orderIds &&
      //     this.lastSubmit.addressId == addressId &&
      //     this.lastSubmit.orderInfo == orderInfo
      //   )
      // ) {
      //   const result = await this.requestOrderSubmit({
      //     orderInfo: orderInfo,
      //     addressId: addressId,
      //   });
      //   this.currentSubmitOrderIds = result.orderList.map(
      //     (item) => item.orderId
      //   );
      //   localStorage.setItem(
      //     "currentSubmitOrderIds",
      //     this.currentSubmitOrderIds
      //   );
      //   this.lastSubmit = {
      //     orderInfo,
      //     orderIds: this.currentSubmitOrderIds,
      //     addressId,
      //   };
      // } else {
      // }
      // if (!this.userInfo.safeword) {
      //   // 设置支付密码
      //   this.payModalShow = true;
      //   this.showModel = 1;
      //   return;
      // }
      // if (!this.checkoutAmount()) {
      //   return;
      // }
      // this.payModalShow = true;
      this.$router.replace("/paySuccess");
    },
    cleartCheckData(ids) {
      this.checkProductPay.forEach((item) => {
        item.list = item.list.filter((listItem) => !ids.includes(listItem.id));
      });
      this.updateCheckProductPay(
        this.checkProductPay.filter((item) => !!item.list.length)
      );
    },
    selectAddressEvent() {
      this.addAddressModalShow = true;
    },
    async payCallback(password, successCallBack, failCallBack) {
      if (!this.checkoutAmount()) {
        return;
      }
      if (!this.currentSubmitOrderIds.length) {
        this.currentSubmitOrderIds = localStorage.getItem(
          "currentSubmitOrderIds"
        );
      }
      await this.requestOrderPay({
        orderId: this.currentSubmitOrderIds.join(","),
        safeword: password,
      })
        .then(() => {
          // let cartItemsData = getCartItemsLocal();
          const cartItemsData = getCartItemsLocal().then(result => {
            return result;
          });
          const checkData = this.getChcekData();
          if (cartItemsData && cartItemsData.length) {
            const checkIds = checkData.map((item) => item.attrTime);
            cartItemsData = cartItemsData.filter(
              (item) => !checkIds.includes(item.attrTime)
            );
            // 支付成功后，清除购物车中的订单
            this.getCartItemsLocal(cartItemsData);
          }
          const list = []
          this.updateCartItems(list)
          successCallBack && successCallBack();
          this.$router.replace("/paySuccess");
        })
        .catch(() => {
          failCallBack && failCallBack();
        })
        .finally(() => {
          localStorage.removeItem("currentSubmitOrderIds");
          this.payModalShow = false;
        });
    },
    checkoutAmount() {
      if (this.isDisabledPayBtn) {
        if (this.checkTotalAmount.at(0) == "0") {
          this.$message({
            message: this.$t(
              "message.home.NoProductSelected" /**还未选择商品 */
            ),
            type: "error",
          });
        } else {
          this.$message({
            message: this.$t("message.home.balanceNot" /**余额不足，请充值 */),
            type: "error",
          });
        }
        this.payModalShow = false;
        return false;
      }
      return true;
    },


    // changeAddressView(){
    //   this.$emit('showAddAddressView')
    // },

    // selectAddress(item) {
    //   this.updatePaySelectAddress(item)
    //   this.dialogVisible = false
    // },



    ////////////////////////////////////////////////methods//////////////////////////////////////////////////

    checkout_init() {
      if (this.$route.query.skuId) {
        this.skuId = this.$route.query.skuId ? this.$route.query.skuId : null;
        this.formData.skuId = this.skuId ? this.skuId : null;
        this.marketingId = this.$route.query.marketingId ? this.$route.query.marketingId : null;
        this.formData.marketingId = this.marketingId ? this.marketingId : null;
        this.notJoinGroup = this.$route.query.notJoinGroup ? true : false;
        this.formData.notJoinGroup = this.$route.query.notJoinGroup ? true : false;
        this.skuQuantity = this.$route.query.quantity ? this.$route.query.quantity : null;
        this.formData.quantity = this.skuQuantity ? this.skuQuantity : null;
        this.orderType = this.$route.query.orderType ? this.$route.query.orderType : null;
      }
      // localStorage.setItem(name, JSON.stringify(obj))
      if (this.currentCart) {
        this.formData.currentCartId = this.currentCart.id;
      }
      //直接购买
      if (this.skuId) {
        this.checkout(this.skuId, this.marketingId, this.skuQuantity);
        //购物车购买
      } else {
        this.checkout(null, null, null);
      } //调用应用实例的方法获取全局数据
    },
    bindPaymentPatternsChange: function (e) {
      this.indexPM = e.detail.value;
      if (this.paymentPatterns && 0 < this.paymentPatterns.length) {
        this.formData.paymentPatternId = this.paymentPatterns[this.indexPM].id;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }

    },
    bindShippingMethodsChange: function (e) {
      this.indexSM = e.detail.value;
      if (this.shippingMethods && 0 < this.shippingMethods.length) {
        this.formData.shippingMethodId = this.shippingMethods[this.indexSM].id;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }
    },
    bindCouponsChange: function (e) {
      this.indexCC = e.detail.value;
      if (this.coupons && 0 < this.coupons.length) {
        this.formData.code = this.coupons[this.indexCC].code;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }
    },

    checkout: function (skuId, marketingId, skuQuantity) {
      this.loading = true;
      //直接购买
      if (skuId) {
        checkout({
          "skuId": skuId ? skuId : null,
          "marketingId": marketingId ? marketingId : null,
          "notJoinGroup": this.notJoinGroup,
          "quantity": skuQuantity ? skuQuantity : null
        }).then(response => {
          this.loading = false;
          //下拉加载
          this.obj = response.data.data;
          this.objsList = response.data.data.cartItems;
          this.paymentPatterns = response.data.data.paymentPatterns;
          this.shippingMethods = response.data.data.shippingMethods;
          this.coupons = response.data.data.coupons;
          let event = {
            'detail': {
              'value': 0,
              "isLoad": true
            }
          };
          this.bindCouponsChange(event);
          this.bindPaymentPatternsChange(event);
          this.bindShippingMethodsChange(event);
          this.defaultAddress = response.data.data.defaultAddress;
          this.formData.addressId = this.defaultAddress.id;
        });
      } else {
        //购物车提交
        checkout({
          "currentCartId": this.currentCart.id
        }).then(response => {
          this.loading = false;
          this.obj = response.data.data;
          this.objsList = response.data.data.cartItems;
          this.paymentPatterns = response.data.data.paymentPatterns;
          this.shippingMethods = response.data.data.shippingMethods;
          this.defaultAddress = response.data.data.defaultAddress;
          this.formData.addressId = this.defaultAddress.id;
          this.coupons = response.data.data.coupons;
          let event = {
            'detail': {
              'value': 0,
              "isLoad": true
            }
          };
          this.bindCouponsChange(event);
          this.bindPaymentPatternsChange(event);
          this.bindShippingMethodsChange(event);



        });
      }

    },

    // 计算
    checkout_calculate() {
      this.loading = true;
      calculate(this.formData).then(response => {
        this.loading = false;
        this.obj.amount = response.data.data.amount; //订单金额
        this.obj.amountPayable = response.data.data.amountPayable; //应付金额
        this.obj.couponDiscount = response.data.data.couponDiscount; //优惠券折扣
        this.obj.exchangePoint = response.data.data.exchangePoint; //兑换积分
        this.obj.fee = response.data.data.fee; //支付手续费
        this.obj.freight = response.data.data.freight; //运费
        this.obj.isDelivery = response.data.data.isDelivery; //是否需要物流
        this.obj.price = response.data.data.price; //价格
        this.obj.marketingDiscount = response.data.data.marketingDiscount; //营销折扣
        this.obj.rewardPoint = response.data.data.rewardPoint; //赠送积分
        this.obj.tax = response.data.data.tax; //税金

      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },


    formSubmit: function (e) {
      this.loading=true;
      if (!this.formData.addressId) {
        this.$message({
            message: "请填选收货地址",
            type: "error",
        });
        return;
      }
      create(this.formData).then(response => {
        this.payModalShow = true;
        //购物车订单提交成功要，根据是否选中，清理购物车前台session缓存
        this.orders = response.data.data.orders;
        this.orderSns = response.data.data.orderSns;
        if (this.orders) {
          let paymentPattern = this.orders[0].paymentPatternType;
          this.payment_payment();
        }
      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },
    guanbi: function () {
      var that = this;
      that.showcartlist = false;
      that.invoiceShow = false;
    },
    showgaozhishu: function () {
      var that = this;
      that.invoiceShow = true;
    },

    // checkout_payment: function () {
    //   this.orderSns = options.orderSns;
    //   this.payment_payment();
    // },

    payment_payment: function () {
      payment(this.orderSns).then(response => {
        this.loading = false;
        this.totalPrice = response.data.data.amount;
        this.orders = response.data.data.orders;
        this.orderSns = response.data.data.orderSns;
        this.online = response.data.data.online;
        this.defaultPayment = response.data.data.defaultPayment;
        this.payments = response.data.data.payments;
        this.shippingMethodName = response.data.data.shippingMethodName;
        this.paymentPatternName = response.data.data.paymentPatternName;
        this.paymentPattern = response.data.data.paymentPattern;
        this.expireDate = response.data.data.expireDate;
        let paymentItem = {};
        for (let i = 0; i < this.orders.length; i++) {
          paymentItem = {};
          paymentItem.type = "ORDER_PAYMENT";
          paymentItem.amount = this.orders[i].amount;
          paymentItem.orderSn = this.orders[i].sn;
          this.paymentItemListForm.paymentItemList.push(paymentItem);
        }

      }).catch(error => {
        this.loading = false;
        console.error("error", error);
        // uni.showToast({
        // 	title: this.messages['common_message_unknownError'],
        // 	duration: 2000
        // });
      })
    },

    payment_outLinePay: function () {
      load(
        this.paymentItemListForm, {
        "paymentId": this.defaultPayment.id,
        "rePayUrl": "test"
      }).then(response => {
        this.loading = false;
        this.paymentLog = response.data.data.paymentLog;
        this.payment_testpostpay();
      }).catch(error => {
        // 关闭loading
        console.error("error", error);
        // /弹出未知错误
      })
    },

    payment_testpostpay: function () {
      testPostPay({
        "extra": "Order pay",
      }, this.paymentLog.sn).then(response => {

        // 支付成功

        // 页面跳转
        this.$router.replace("/paySuccess");

        // setTimeout(function () {
        //   uni.reLaunch({
        //     url: '../../pages/member/index'
        //   });
        // }, 3000);

      }).catch(error => {
        // 弹出未知错误
        console.error("error", error);
      })
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

  },
};
</script>

<style lang="scss">
.settlement {
  &-content {
    .title {
      font-weight: 600;
      font-size: 24px;
      color: var(--color-title);
      margin-bottom: 12px;
    }

    .subtitle {
      font-weight: 600;
      font-size: 20px;
      color: var(--color-title);
      margin-bottom: 15px;
    }
  }

  &-receiver {
    border: 1px solid var(--color-border);
    padding: 16px 20px;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .userinfo {
      font-weight: 500;
      font-size: 12px;
      color: var(--color-title);
      margin-bottom: 5px;
    }

    .address {
      display: inline-block;
      font-weight: 500;
      max-width: 1000px !important;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
      font-size: 12px;
      color: var(--color-subtitle);
    }

    div:first-child {
      flex: 1;
    }

    div:last-child {
      width: 50px;
      text-align: right;
    }
  }

  &-pay {
    border: 1px solid var(--color-border);
    padding: 11px 20px;
    margin: 40px 0;

    &-label {
      font-weight: 500;
      font-size: 12px;
      color: var(--color-title);

      span {
        color: var(--color-main);
      }
    }

    .el-button {
      font-weight: 700;
      font-size: 14px;
      color: var(--color-white);

      span:first-child {
        margin-right: 10px;
      }
    }
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////
html[dir="rtl"] {
  .settlement {
    .settlement-commodity-wrap .el-input-number {
      left: 24px;
      right: auto;
    }

    .settlement-commodity-item img {
      // margin-right: 5px;
      margin-left: 18px;
    }

    .el-checkbox__label {
      padding-right: 10px;
      padding-left: 0;
    }
  }
}

.settlement {
  .settlement-commodity-info-attr {
    color: #666;
    padding-top: 4px;
    font-size: 12px;
  }

  &-commodity {
    padding-bottom: 20px;

    &-title {
      margin-bottom: 11px;
      margin-top: 18px;

      .el-checkbox__label {
        font-weight: 500;
        font-size: 12px;
        color: var(--color-title);
      }
    }

    &-wrap {
      position: relative;

      .el-input-number {
        width: 100px;
        position: absolute;
        top: 30px;
        right: 24px;
      }

      .el-input-number__decrease,
      .el-input-number__increase {
        background-color: var(--color-white);
      }
    }

    &-wrap:first-child {
      .el-checkbox {
        border-top: 0;
      }
    }

    &-group {
      border: 1px solid var(--color-border);
      border-radius: 4px;
      padding: 10px;
    }

    &-item {
      img {
        width: 62px;
        height: 62px;
        margin-right: 18px;
        object-fit: contain;
      }
    }

    &-info {
      flex: 1;

      div {
        width: 100%;
      }

      h2 {
        font-weight: 400;
        font-size: 14px;
        color: var(--color-black);
        margin-bottom: 10px;
        max-width: 800px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        color: var(--color-price);
      }
    }

    &-checkbox {
      display: flex !important;
      padding: 20px 10px;
      border-top: 1px solid var(--color-border);

      .el-checkbox__label {
        flex: 1;
      }
    }

    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
}



////////////////////////////////////////////////////////////////////////////////////////////

.order-sum {
  margin-bottom: 20px;

  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--color-title);
    margin: 18px 0;
  }

  &-content {
    background-color: var(--color-little-grey);
    padding: 0 28px;
    border-radius: 4px;

    li {
      font-weight: 600;
      font-size: 14px;
      padding: 15px 0;

      span:first-child {
        color: var(--color-subtitle);
      }

      span:last-child {
        color: var(--color-black);
      }
    }

    .total {
      border-top: 1px solid var(--color-border);

      span {
        color: var(--color-price) !important;
      }
    }
  }
}

///////////////////////////////////////////////////////////////////////////////////////////

.item {
  width: 100%;
  border: 1px solid var(--color-border);
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;

  &:hover {
    border-color: var(--color-main);
  }

  .info {
    margin-bottom: 8px;
  }
}

.address-active {
  border-color: var(--color-main);
}

////////////////////////////////////////////////////////////////////////////////////////////


html[dir="rtl"] {
  .pay-method-item-left .name {
    margin-right: 5px;
  }
}

.pay-method {
  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--color-title);
    margin: 18px 0;
  }

  &-content {
    background: linear-gradient(0deg, #fff7ec, #fff7ec), #eeeeee;
    border-radius: 4px;
    padding: 0 28px;
  }

  &-item {
    padding: 15px 0;

    &-left {
      img {
        width: 20px;
      }

      .name {
        min-width: 200px;
        margin-left: 5px;

        span:first-child {
          font-weight: 600;
          font-size: 14px;
          color: var(--color-black);
        }
      }

      .amount {
        color: var(--color-price);
        font-weight: 600;
      }

      .not-bind {
        color: var(--color-subtitle);
        font-weight: 600;
      }

      .tips {
        color: var(--color-subtitle);
        font-weight: 400;

        i {
          color: var(--color-main);
        }
      }
    }

    .el-radio__label {
      display: none;
    }

    .el-radio__inner {
      background-color: #d9d9d9;
    }
  }
}
</style>
